<app-back-header-atom
  icon="arrow-left"
  [text]="'cart-funnel.title' | translate"
  (navigationClick)="back()"
></app-back-header-atom>
